module.exports = "<div class=\"msgSnack\">\n    <img src=\"/assets/img/{{data.img}}\">\n    <span>{{_i18n.trans(data.msg)}}</span>\n</div>\n"